export const FTCEnabled = process.env.NEXT_PUBLIC_FTC_ENABLED === 'true';

export const FTCEnabledSkus = [
  'HOMEPRO',
  'PDPE',
  'PDPO',
  'PDPF',
  'CRICKETHOMEPLUS',
  'BOOMERANGHOME',
  'VIUHOMEPLUS',
  'VIUAPPPROTECT',
  'HOMEPLUS3000',
  'HOMEPLUSENT',
  'APPLHOMEPLUS30',
  'APPLHOMEPLUS35_99',
];
